export default __webpack_public_path__ + "static/media/open-positions-pop-up-tablet.f64cb5e0.jpg";